module.exports = __webpack_public_path__ + "assets/cdf6b538a01ce6c582e81dd85f9a735e.png";